import { call, put, takeLatest } from "redux-saga/effects";
import Swal from "sweetalert2";
import * as types from "./actionTypes"; // make sure the action types match
import { post, get } from "../../../helpers/api_helper"; // adjust the path accordingly

// 🟡 Fetch Permission Policy
function* fetchPermissionPolicySaga(action) {
  const {unit_id} = action.payload;
  try {
    const formData = new FormData()
    formData.append("unit_id", unit_id);
    const response = yield call(post, process.env.REACT_APP_FETCH_PERMISSION_POLICY,formData);

    if (!response || response.status !== "success") {
      throw new Error(response?.message || "Failed to fetch permission policy!");
    }

    yield put({ type: types.FETCH_PERMISSION_POLICY_SUCCESS, payload: response });
  } catch (error) {
    Swal.fire({
      title: "Error",
      text: error.message || "Something went wrong while fetching permission policy!",
      icon: "error",
      confirmButtonText: "OK",
    });

    yield put({ type: types.FETCH_PERMISSION_POLICY_FAILURE, payload: error });
  }
}

// 🟢 Save Permission Policy
function* savePermissionPolicySaga(action) {
  try {
    const response = yield call(post, process.env.REACT_APP_SAVE_PERMISSION_POLICY, action.payload);

    if (!response || response.status !== "success") {
      throw new Error(response?.message || "Failed to save permission policy!");
    }

    Swal.fire({
      title: "Success",
      text: response?.message || "Permission Policy saved successfully!",
      icon: "success",
      confirmButtonText: "OK",
    });

    yield put({ type: types.SAVE_PERMISSION_POLICY_SUCCESS, payload: response });
  } catch (error) {
    Swal.fire({
      title: "Error",
      text: error.message || "Something went wrong while saving permission policy!",
      icon: "error",
      confirmButtonText: "OK",
    });

    yield put({ type: types.SAVE_PERMISSION_POLICY_FAILURE, payload: error });
  }
}

// 🔁 Root Saga
export default function* permissionPolicySaga() {
  yield takeLatest(types.FETCH_PERMISSION_POLICY_REQUEST, fetchPermissionPolicySaga);
  yield takeLatest(types.SAVE_PERMISSION_POLICY_REQUEST, savePermissionPolicySaga);
}
